import * as React from 'react';
import { compose } from 'redux';
import { reduxForm } from 'redux-form';
import type { InjectedFormProps } from 'redux-form';

import { useToggle } from 'af-utils/react.util';

import { Button } from '@acceligentllc/storybook';

import EmailForm from './EmailForm';
import { EmailContactFM } from './formModel';
import styles from './styles.module.scss';

interface OwnProps {
	createEmail: (form: EmailContactFM) => Promise<void>;
	form: string;
}

type Props = OwnProps & InjectedFormProps<EmailContactFM>;

const EmailCreate: React.FC<Props> = (props) => {

	const {
		createEmail,
		reset,
	} = props;

	const {
		value: addingEmail,
		setToTrue: toggleAddingEmailOn,
		setToFalse: toggleAddingEmailOff,
	} = useToggle(false);

	const handleCreateEmail = React.useCallback(async (form: EmailContactFM) => {
		await createEmail(form);
		toggleAddingEmailOff();
		reset();
	}, [createEmail, reset, toggleAddingEmailOff]);

	return (
		<div className={styles['create-email']}>
			{addingEmail ?
				(<EmailForm onSubmit={handleCreateEmail} toggleInputEditOff={toggleAddingEmailOff} {...props} />)
				: (
					<Button
						icon="ActionPlusSmall"
						label="Add Email"
						onClick={toggleAddingEmailOn}
						style="link"
					/>
				)}
		</div>
	);
};

const enhance = compose<React.ComponentType<OwnProps>>(
	React.memo,
	reduxForm<EmailContactFM>({
		validate: EmailContactFM.validate,
	})
);

export default enhance(EmailCreate);
